import { trackQBEvent } from '@modules/queryBuilder/events';
import {
  getNewFilterNode,
  upsertQueryFilterNode,
} from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import FilterAltRounded from '@mui/icons-material/FilterAltRounded';
import { Button, ButtonProps } from '@mui/material';

export function AddQueryFilterButton(props: ButtonProps) {
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);
  const nodes = useQueryBuilderStore(({ query }) => query.nodes);
  const parentID = useQueryBuilderStore(({ query }) => query.rootID);
  const isDisabled = useQueryBuilderStore(
    ({ metadata }) =>
      metadata.isEmpty ||
      metadata.hasIncompleteFilters ||
      Boolean(metadata.error),
  );

  const addFilter = () => {
    const node = getNewFilterNode({ parentID });

    const updatedNodes = upsertQueryFilterNode({
      nodesByID: nodes,
      parentID,
      node,
    });

    dispatch({
      type: QueryBuilderActionType.SET_QUERY,
      payload: {
        nodes: updatedNodes,
        rootID: parentID,
      },
    });

    dispatch({
      type: QueryBuilderActionType.SET_METADATA,
      payload: {
        filterIDUnderInspect: node.id,
      },
    });

    trackQBEvent({
      eventName: 'Query Builder Action Event',
      action: {
        type: 'NEW_FILTER',
        nested: false,
        display: '',
        searchMetadata: '',
      },
    });
  };

  return (
    <Button
      {...props}
      disabled={isDisabled}
      startIcon={<FilterAltRounded />}
      onClick={addFilter}
    >
      Add filter
    </Button>
  );
}
